// Generated by ts-to-zod
import { z } from 'zod';
import { urlSchema } from '../../utils/codecUtils.schema';

export const rawSchemaSchema = z.object({
  id: z.number(),
  name: z.string(),
  url: urlSchema,
  queues: z.array(urlSchema),
  metadata: z.unknown().optional(),
  content: z.unknown().optional(),
  modifiedBy: urlSchema.nullable(),
  modifiedAt: z.string().nullable(),
});
